import type * as Types from '@shared/types/graphqlGenerated';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type PatientDiscountIncrementsSharedQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PatientDiscountIncrementsSharedQuery = { currentStore: { __typename: 'Store', id: string, patientDiscountIncrements: Array<number> } | null };


export const PatientDiscountIncrementsSharedQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PatientDiscountIncrements_Shared_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"patientDiscountIncrements"}}]}}]}}]} as unknown as DocumentNode;
export type PatientDiscountIncrementsSharedQueryQueryResult = Apollo.QueryResult<PatientDiscountIncrementsSharedQuery, PatientDiscountIncrementsSharedQueryVariables>;

export function usePatientDiscountIncrementsSharedQuery(
  baseOptions?: Apollo.QueryHookOptions<PatientDiscountIncrementsSharedQuery, PatientDiscountIncrementsSharedQueryVariables>
) {
  return Apollo.useQuery<PatientDiscountIncrementsSharedQuery, PatientDiscountIncrementsSharedQueryVariables>(
    PatientDiscountIncrementsSharedQueryDocument,
    baseOptions
  );
}

export function usePatientDiscountIncrementsSharedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientDiscountIncrementsSharedQuery, PatientDiscountIncrementsSharedQueryVariables>) {
  return Apollo.useLazyQuery<PatientDiscountIncrementsSharedQuery, PatientDiscountIncrementsSharedQueryVariables>(
    PatientDiscountIncrementsSharedQueryDocument,
    baseOptions
  );
}

export function usePatientDiscountIncrementsSharedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PatientDiscountIncrementsSharedQuery, PatientDiscountIncrementsSharedQueryVariables>) {
  return Apollo.useSuspenseQuery<PatientDiscountIncrementsSharedQuery, PatientDiscountIncrementsSharedQueryVariables>(
    PatientDiscountIncrementsSharedQueryDocument,
    baseOptions
  );
}
